import Sortable from "@stimulus-components/sortable"
import { patch } from "@rails/request.js"

export class Controller extends Sortable {
  static targets = ["phase", "material"]

  get defaultOptions() {
    return {
      onMove: this.onMove.bind(this),
    }
  }

  // Do not allow a material to move above the batch's first phase
  onMove(evt) {
    const firstPhase = this.phaseTargets[0]

    if (!firstPhase) return

    if (evt.related === firstPhase && !evt.willInsertAfter) return false
  }

  async onUpdate({ item, newIndex }) {
    const data = this._formData(item, newIndex)

    const response = await patch(item.dataset.sortableUpdateUrl, {
      body: data,
      responseKind: this.responseKindValue,
    })

    if (response.ok) this.refreshHistory()
  }

  // Refresh history frame when moving a material
  refreshHistory() {
    document.getElementById("history")?.reload()
  }

  _formData(item, _newIndex) {
    const data = new FormData()
    data.append("position", this._position(item))
    data.append("phase", this._phase(item))

    return data
  }

  _position(item) {
    const rows = Array.from(item.parentElement.children).filter((el) =>
      this.materialTargets.includes(el)
    )

    return rows.indexOf(item) + 1
  }

  _phase(item) {
    let node = item.previousElementSibling

    while (node) {
      if (this.phaseTargets.includes(node)) return node.dataset.phase
      node = node.previousElementSibling
    }

    return this.phaseTargets[0]?.dataset.phase
  }
}
